import {Component, inject, Injector} from '@angular/core';
import {DialogBaseComponent} from "../../base-admin-panel/dialog-base/dialog-base.component";
import {RetranslationStatus, RetranslationViewModel} from "../Models/RetranslationViewModel";
import {RetranslationService} from "../../../../services/retranslation.service";
import {Protocol} from "../Models/Protocols";

@Component({
    selector: 'app-retranslator-dialog-base',
    templateUrl: './retranslator-dialog-base.component.html',
    styleUrls: ['./retranslator-dialog-base.component.css'],
    standalone: false
})
export class RetranslatorDialogBaseComponent extends DialogBaseComponent<RetranslationViewModel> {

  public protocols: any[];
  public statuses: any[];
  protected retranslationService: RetranslationService = inject(RetranslationService);
  public openedTabName: string = "main";

  constructor(injector: Injector) {
    super(injector);

    // Get retranslation protocols as string[]
    this.protocols = Object.keys(Protocol)
      .filter(key => !isNaN(Number(Protocol[key])))
      .map(key => ({
        text: key,
        value: Protocol[key as keyof typeof Protocol]
      }));
    this.statuses = Object.keys(RetranslationStatus)
      .filter(key => !isNaN(Number(RetranslationStatus[key])))
      .map(key => ({
        text: this.translate.instant(key),
        value: RetranslationStatus[key as keyof typeof RetranslationStatus]
      }));
  }

  protected readonly Protocol = Protocol;

  public openTab(name: string) {
    this.openedTabName = name;
  }
  public isSelected(name: string) {
    return name == this.openedTabName;
  }

  public onProtocolChange(event: Event) {
    this.model.Protocol = Number((event.target as HTMLInputElement).value);
  }

  public onStatusChange(event: Event) {
    this.model.Status = Number((event.target as HTMLInputElement).value);
  }

  protected validate(): boolean {
    if (!this.model.Name) {
      this.toastr.error(this.translate.instant('The name field is required'));
      return false;
    }

    return true;
  }
}
